var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"fill-height",attrs:{"fluid":""}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12","sm":"10","md":"6"}},[_c('v-card',{staticClass:"pa-3",attrs:{"flat":""}},[_c('v-card-title',[_vm._v(" "+_vm._s(_vm.error)+" ")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }